export default __webpack_public_path__ + "static/media/feat-mining.df4e846c.svg";